import { createContext, useContext, useEffect, useState } from "react";
import { useUserData } from "./userContext";
import { keikkaTila_saveToDB_static, tila_getTilaType } from "src/data/tilaClass";
import PropTypes from "prop-types";
import { fetchPersonKeikkasDetailed } from "src/data/person/personClass";
import { getAllPersonNotifications } from "src/data/system/firebaseClass";

export const FPTilauksetContext = createContext();

export const FPTilauksetProvider = ({ children }) => {
  const { user, token, socket } = useUserData();
  const [dates, setDates] = useState({ startDate: new Date(), endDate: new Date() });
  const [keikat, setKeikat] = useState([]);
  const [allKeikat, setAllKeikat] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [suodata, setSuodata] = useState("");
  const [filterBySourceAsiakkaat, setFilterBySourceAsiakkaat] = useState([]);

  const [suodataKey, setSuodataKey] = useState(0);
  const [filterByTila, setFilterByTila] = useState({
    luonnos: true,
    lähetetty: true,
    käsittelyssä: true,
    toimitusvalmis: true,
    meneillään: true,
    toimitettu: true,
    valmis: true,
    muut: false,
    poistettu: false,
  });
  const [keikkaCounts, setKeikkaCounts] = useState({
    luonnos: 0,
    lähetetty: 0,
    käsittelyssä: 0,
    toimitusvalmis: 0,
    meneillään: 0,
    toimitettu: 0,
    valmis: 0,
    muut: 0,
    poistettu: 0,
  });

  const isKeikkaAdmin = user && user.settings.isKeikkaAdmin;
  const hasMultipleKeikkas = user && user.settings.hasMultipleKeikkas;
  const personId = user && user.personId;
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  // load on start
  useEffect(() => {
    // set filterByTila from localStorage
    const _lTila = localStorage.getItem("filterByTila");
    if (_lTila && _lTila !== "undefined") setFilterByTila(JSON.parse(_lTila));
  }, []);

  // refresh keikat when date changes
  useEffect(() => {
    if (!user) return;
    if (user.personId === 0) return;
    const asyncFunc = async () => {
      // fetch keikat
      const _allKeikat = await fetchAllKeikat();
      setKeikat(_allKeikat);
      setAllKeikat(_allKeikat);
      setIsLoading(false);
      setIsLoaded(true);
      // fetch notifications
      const n = await fetchNotifications();
      setNotifications(n);
    };
    setIsLoading(true);
    asyncFunc();
  }, [personId, dates]);

  // set keikkaCounts when keikat changes
  useEffect(() => {
    if (keikat == null) return;
    const asyncFunc = async () => {
      var _luonnos = [];
      var _lähetetty = [];
      var _käsittelyssä = [];
      var _toimitusvalmis = [];
      var _meneillään = [];
      var _toimitettu = [];
      var _valmis = [];
      var _muut = [];
      var _poistettu = [];

      for (let i = 0; i < keikat.length; i++) {
        const tilaId = keikat[i].keikkaTilaId;
        const tilaType = await tila_getTilaType(tilaId);
        switch (tilaType) {
          case "luonnos":
            _luonnos.push(keikat[i]);
            break;
          case "lähetetty":
            _lähetetty.push(keikat[i]);
            break;
          case "käsittelyssä":
            _käsittelyssä.push(keikat[i]);
            break;
          case "toimitusvalmis":
            _toimitusvalmis.push(keikat[i]);
            break;
          case "meneillään":
            _meneillään.push(keikat[i]);
            break;
          case "toimitettu":
            _toimitettu.push(keikat[i]);
            break;
          case "toimitettu1":
            _toimitettu.push(keikat[i]);
            break;
          case "toimitettu2":
            _toimitettu.push(keikat[i]);
            break;
          case "toimitettu3":
            _toimitettu.push(keikat[i]);
            break;
          case "valmis":
            _valmis.push(keikat[i]);
            break;
          case "poistettu":
            _poistettu.push(keikat[i]);
            break;
          case "muut":
            _muut.push(keikat[i]);
            break;
          default:
            _muut.push(keikat[i]);
            break;
        }
      }
      setKeikkaCounts({
        luonnos: _luonnos,
        lähetetty: _lähetetty,
        käsittelyssä: _käsittelyssä,
        toimitusvalmis: _toimitusvalmis,
        meneillään: _meneillään,
        toimitettu: _toimitettu,
        valmis: _valmis,
        muut: _muut,
        poistettu: _poistettu,
      });
    };
    asyncFunc();
    return () => {};
  }, [keikat]);

  useEffect(() => {
    if (!user) return;
    if (personId === 0) return;
    if (allKeikat == null) return;
    if (suodata.length > 0) {
      //const startFunc = performance.now();
      const found = [];
      const s = suodata.toLowerCase();
      for (let i = 0; i < allKeikat.length; i++) {
        const _keikka = allKeikat[i];
        if (_keikka.asiakasNimi.toLowerCase().includes(s)) {
          found.push(_keikka);
          continue;
        }
        if (_keikka.keikkaOtsikko && _keikka.keikkaOtsikko.toLowerCase().includes(s)) {
          found.push(_keikka);
          continue;
        }
        if (_keikka.keikkaComment && _keikka.keikkaComment.toLowerCase().includes(s)) {
          found.push(_keikka);
          continue;
        }
        if (_keikka.kommentti && _keikka.kommentti.toLowerCase().includes(s)) {
          found.push(_keikka);
          continue;
        }
        if (_keikka.tyomaaAjoOhje && _keikka.tyomaaAjoOhje.toLowerCase().includes(s)) {
          found.push(_keikka);
          continue;
        }
        if (_keikka.tyomaaNimi && _keikka.tyomaaNimi.toLowerCase().includes(s)) {
          found.push(_keikka);
          continue;
        }
        if (_keikka.tyomaaOsoite && _keikka.tyomaaOsoite.toLowerCase().includes(s)) {
          found.push(_keikka);
          continue;
        }
        if (_keikka.tyomaaOsoite1 && _keikka.tyomaaOsoite1.toLowerCase().includes(s)) {
          found.push(_keikka);
          continue;
        }
        if (_keikka.tyomaaOsoite2 && _keikka.tyomaaOsoite2.toLowerCase().includes(s)) {
          found.push(_keikka);
          continue;
        }
        if (_keikka.tyomaaOsoite3 && _keikka.tyomaaOsoite3.toLowerCase().includes(s)) {
          found.push(_keikka);
          continue;
        }
        if (_keikka.tyomaaOsoite4 && _keikka.tyomaaOsoite4.toLowerCase().includes(s)) {
          found.push(_keikka);
          continue;
        }
        if (_keikka.personEmail && _keikka.personEmail.toLowerCase().includes(s)) {
          found.push(_keikka);
          continue;
        }
        if (_keikka.personFirstName && _keikka.personFirstName.toLowerCase().includes(s)) {
          found.push(_keikka);
          continue;
        }
        if (_keikka.personLastName && _keikka.personLastName.toLowerCase().includes(s)) {
          found.push(_keikka);
          continue;
        }
        if (_keikka.personMemo && _keikka.personMemo.toLowerCase().includes(s)) {
          found.push(_keikka);
          continue;
        }
        if (_keikka.personPhone && _keikka.personPhone.toLowerCase().includes(s)) {
          found.push(_keikka);
          continue;
        }
      }
      setKeikat(found);
    } else {
      setKeikat(allKeikat);
    }
  }, [suodata, suodataKey, allKeikat]);

  // Filter keikat by selected sourceAsiakkaat
  useEffect(() => {
    if (!allKeikat) return;
    // Only filter if filterBySourceAsiakkaat is set and not all are selected
    if (
      filterBySourceAsiakkaat &&
      filterBySourceAsiakkaat.length > 0 &&
      filterBySourceAsiakkaat.length <
        Array.from(new Set(allKeikat.map((k) => k.sourceAsiakasId))).length
    ) {
      const filtered = allKeikat.filter((k) => filterBySourceAsiakkaat.includes(k.sourceAsiakasId));
      setKeikat(filtered);
    } else {
      setKeikat(allKeikat);
    }
  }, [filterBySourceAsiakkaat, allKeikat]);

  const doSetFilterByTila = (newFilterByTila) => {
    setFilterByTila((prevState) => {
      const newState = newFilterByTila(prevState);
      localStorage.setItem("filterByTila", JSON.stringify(newState));
      return newState;
    });
  };

  const getKeikat = async (startDate, endDate) => {
    const res = await fetchPersonKeikkasDetailed(personId, token, startDate, endDate);
    const today = new Date();
    for (let i = 0; i < res.length; i++) {
      const _keikkaTilaId = res[i].keikkaTilaId;
      // 4 = toimitusvalmis, 5 = toimitus meneillään
      if (_keikkaTilaId == 3 || _keikkaTilaId == 4 || _keikkaTilaId == 5) {
        const _pumppuAika = res[i].pumppuAika;
        const _pumppuKesto = res[i].pumppuKesto;
        const foreignKey = res[i].foreignKey;

        var endTime = new Date(_pumppuAika);
        endTime.setHours(endTime.getHours() + _pumppuKesto / 60);
        if (_keikkaTilaId == 4 && _pumppuAika < today && endTime > today) {
          console.log("UPDATE TO TILAUS TOIMITUS MENEILLÄÄN");
          res[i].keikkaTilaId = 5;
          res[i].keikkaTilaSelite = "Toimitus meneillään";
          keikkaTila_saveToDB_static(res[i].keikkaId, 5, personId, token, socket);
        }

        if (
          (_keikkaTilaId == 4 || // toimitusvalmis
            _keikkaTilaId == 5 || // toimitus meneillään
            (foreignKey != null && _keikkaTilaId == 3)) && // isImported + käsittelyssä
          endTime < today
        ) {
          console.log("UPDATE TO TILAUS TOIMITETTU" + res[i].keikkaId);
          res[i].keikkaTilaId = 5;
          res[i].keikkaTilaSelite = "Tilaus toimitettu";
          keikkaTila_saveToDB_static(res[i].keikkaId, 9, personId, token, socket);
        }
      }
    }
    return res;
  };
  const fetchNotifications = async () => {
    const keikkaTilaId = 4; // 4=toimitusvalmis // keikkaData.tila.keikkaTilaId;
    const _n = await getAllPersonNotifications(token, user.personId, keikkaTilaId);
    return _n;
  };

  const fetchAllKeikat = async () => {
    let _startDate = dates.startDate || new Date();
    let _endDate = dates.endDate || new Date();
    if (isKeikkaAdmin || hasMultipleKeikkas) {
      if (_startDate == null) {
        _startDate.setDate(_startDate.getDate() - 7);
        _endDate.setDate(_startDate.getDate() + 30);
      } else {
        _startDate = new Date(_startDate);
        _endDate = new Date(_endDate);
      }
    } else {
      _startDate.setDate(_startDate.getDate() - 365);
      _endDate.setDate(_endDate.getDate() + 365);
    }
    const res = await getKeikat(_startDate, _endDate);
    // sort by keikkaId
    res.sort((a, b) => (a.keikkaId > b.keikkaId ? 1 : -1));
    let _res = [];
    let prevousKeikkaId = 0;
    let betoniCount = 1;
    let betoniCountString = "";
    if (!hasMultipleKeikkas && res.length > 10) user.settings.hasMultipleKeikkas = true;
    for (let i = 0; i < res.length; i++) {
      if (res[i].keikkaId == prevousKeikkaId) {
        betoniCount++;
        betoniCountString += "+" + res[i].m3;
        _res[_res.length - 1].m3 += res[i].m3;
        _res[_res.length - 1].betoniCount = betoniCount;
        _res[_res.length - 1].betoniCountString = betoniCountString;
        continue;
      }
      prevousKeikkaId = res[i].keikkaId;
      res[i].betoniCount = betoniCount;
      _res.push(res[i]);
      betoniCount = 1;
      betoniCountString = res[i].m3;
    }
    return _res;
  };

  const reloadAll = async () => {
    const _allKeikat = await fetchAllKeikat();
    setKeikat(_allKeikat);
    setAllKeikat(_allKeikat);
    setIsLoading(false);
    const n = await fetchNotifications();
    setNotifications(n);
  };

  const refeshSuodata = () => {
    setSuodataKey(suodataKey + 1);
  };

  return (
    <FPTilauksetContext.Provider
      value={{
        dates,
        setDates,
        keikat,
        allKeikat,
        isLoading,
        setIsLoading,
        isLoaded,
        notifications,
        reloadAll,
        filterByTila,
        doSetFilterByTila,
        keikkaCounts,
        suodata,
        setSuodata,
        refeshSuodata,
        filterBySourceAsiakkaat,
        setFilterBySourceAsiakkaat,
      }}>
      {children}
    </FPTilauksetContext.Provider>
  );
};

export const useFPTilaukset = () => useContext(FPTilauksetContext);

FPTilauksetProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
